import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router , RouterModule } from '@angular/router';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-delete-paymet-inst-success',
  templateUrl: './delete-paymet-inst-success.component.html',
  styleUrls: ['./delete-paymet-inst-success.component.scss'],
})
export class DeletePaymetInstSuccessComponent implements OnInit {
  accountNumber: any;
  isAcmic = false;
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private acmicService: AcmicService
  ) {}

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.accountNumber = history.state.bankAccount;
  }
}
